import React from "react";
import styled from "styled-components";
import { MdClose } from "react-icons/md";
import { COLORS } from "../../COLORS";
import { Dynamic } from "../Context/ContextDynamic";
import axios from "axios";
type TypeProps = {
  setAdsHome: React.Dispatch<React.SetStateAction<boolean>>;
};
const AdsHome = ({ setAdsHome }: TypeProps) => {
  const {
    linkBusinessImgPro,
    linkBusinessPro,
    idBusinessPro,
    setLinkBusinessImgPro,
    setLinkBusinessPro,
    setIdBusinessPro,
  } = Dynamic();
  const closeThisComponent = () => {
    setLinkBusinessImgPro("");
    setLinkBusinessPro("");
    setIdBusinessPro("");
    setAdsHome(false);
  };

  const goRedirection = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
    e.stopPropagation();
    if (
      window.confirm("Vous allez être redirigé vers le lien de l’annonceur")
    ) {
      if (process.env.REACT_APP_API !== "http://localhost:5008/") {
        countClick(idBusinessPro);
      }
      if (linkBusinessPro) {
        window.open(linkBusinessPro, "_blank", "noopener,noreferrer");
      }
      // if (linkBusinessPro) {
      //   window.location.href = linkBusinessPro;
      // }
    }
  };

  const countClick = async (id: string) => {
    try {
      const res = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API}partenaire/check/${id}`,
        withCredentials: true,
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <StyledAdsHome
      onClick={() => closeThisComponent()}
      className="animate__animated animate__bounceIn"
    >
      <MdClose className="icon-close" onClick={() => setAdsHome(true)} />
      <a>
        <img
          src={linkBusinessImgPro}
          alt="img display"
          onClick={(e) => goRedirection(e)}
        />
      </a>
    </StyledAdsHome>
  );
};

export default AdsHome;

const StyledAdsHome = styled.div`
  position: fixed;
  background: greenyellow;
  height: 100vh;
  width: 100%;
  z-index: 80;
  background: #292928c2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
  .icon-close {
    color: ${COLORS.danger};
    font-size: 3em;
    cursor: pointer;
    margin-bottom: 10px;
  }
  a {
    display: block;
    width: 30%;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  //width =< 429px
  @media screen and (max-width: 445px) {
    padding-top: 50px;
    justify-content: flex-start;
    a {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
`;
